<template>
   <div class="price">
       <p class="title">{{ title }}</p>
       <div class="inputs">
           <input type="text"
                  v-model="inputMin"
           >
           <input type="text"
                  v-model="inputMax"
           >
           <input type="hidden" name="min" id="minVal">
           <input type="hidden" name="max" id="maxVal">
       </div>
       <Slider v-model="value"
               :tooltips="false"
               :min="sum.min"
               :max="sum.max"
               @change="handleUpdate(value)"

       />
   </div>
</template>

<script>
import { ref, computed, reactive, toRefs, onMounted, inject } from 'vue'

import Slider from '@vueform/slider'

export default {

    components: {
        Slider
    },

    props: {
        title: '',
        priceFromLabel: '',
        priceToLabel: '',
        sum: {
            required: true,
            type: Object
        }
    },

    setup(props, { emit }) {

        const value = ref([props.sum.min, props.sum.max])

        const state = reactive({
            inputMin: `${props.priceFromLabel}: ${props.sum.min} €`,
            inputMax: `${props.priceToLabel}: ${props.sum.max} €`,
            isMounted: true
        })

        const emitter = inject('emitter')

        onMounted( () => {

            state.isMounted = false

            emitter.on('set-values-from-parameters', ({ min, max }) => {
                if ( (min && max) && (min.length && max.length) ) {
                    value.value = [min, max]
                    setValues(min, max)
                }
            })

            setTimeout( () => state.isMounted = true, 200)
        })

        function handleUpdate(value) {

            setValues(value[0], value[1])

            if ( state.isMounted && window.innerWidth > 991 ) {
                setTimeout( () => {
                    emit('on-price-changed')
                }, 50)
            }
        }

        let valueMin = computed({
            get() {
                return `Od: ${state.inputMin} €`
            },
            set(newValue) {
                state.inputMin = `Od: ${newValue} €`
            }
        })

        let valueMax = computed({
            get() {
                return `Do: ${state.inputMax} €`
            },
            set(newValue) {
                state.inputMax = `Do: ${newValue} €`
            }
        })

        function setValues(min, max) {
            valueMin.value = min
            valueMax.value = max
            document.getElementById('minVal').value = min
            document.getElementById('maxVal').value = max
        }

        return {
            value,
            handleUpdate,
            valueMin,
            valueMax,
            ...toRefs(state)
        }
    }
}
</script>

<style src="@vueform/slider/themes/default.css"></style>
